import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@mantine/core';
import { IoWarning, IoClose } from 'react-icons/io5';
import { getProfileData } from '../../store/profile.slice';
import { BannerWrapper, BannerText } from './CalendarReauthBanner.styles';

export default function CalendarReauthBanner() {
  const profile = useSelector(getProfileData);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('calendarReauthBannerDismissed') === 'true'
  );

  if (!profile?.calendar_reauth_required || dismissed) return null;

  return (
    <BannerWrapper>
      <BannerText>
        <IoWarning size={20} />
        <span>{profile.calendar_reauth_message}</span>
      </BannerText>
      <Button
        size="xs"
        className="reauth-reconnect-btn"
        onClick={() => navigate('/settings/calendar-sync')}
      >
        {formatMessage({ id: 'reconnect' })}
      </Button>
      <IoClose
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setDismissed(true);
          sessionStorage.setItem('calendarReauthBannerDismissed', 'true');
        }}
      />
    </BannerWrapper>
  );
}
